import { OdataManager } from '@/api/odata/odata-manager';
import { Kfo } from '@/api/model/interfaces';

export default class KfoOdata extends OdataManager<Kfo> {}
